import $ from 'jquery';

// Qty in cart
$(document).on('click', '.js-less-cart-qty', function(e) {
  e.preventDefault();
  var step = parseInt($(this).siblings('input.qty').attr('step'));
  var min = parseInt($(this).siblings('input.qty').attr('min'));
  var current_value = parseInt($(this).siblings('input.qty').val());
  // Reduce step by step
  var v = current_value - step;
  // Check min value
  v = (v < min) ? min : v;
  // apply value
  $(this).siblings('input.qty').val(v);
  $('input[name="update_cart"]').removeAttr('disabled');
  $('.woocommerce-cart-form :input[name="update_cart"]').prop('disabled', false);
});

$(document).on('click', '.js-more-cart-qty', function(e) {
  e.preventDefault();
  var step = parseInt($(this).siblings('input.qty').attr('step'));
  var max = parseInt($(this).siblings('input.qty').attr('max'));
  var current_value = parseInt($(this).siblings('input.qty').val());
  // Reduce step by step
  var v = current_value + step;
  // Check min value
  v = (max != '' && v > max) ? max : v;
  // apply value
  $(this).siblings('input.qty').val(v);
  $('input[name="update_cart"]').removeAttr('disabled');
  $('.woocommerce-cart-form :input[name="update_cart"]').prop('disabled', false);
});
